import {NgModule} from "@angular/core";
import {CommonModule} from "@angular/common";
import {IntDefaultInputComponent} from "./int-default-input.component";
import {IntFieldBoxModule, IntLabeledFieldBoxModule} from "../../boxes";
import {IntDefaultInputField} from "./int-default-input-field.component";
import {FormsModule, ReactiveFormsModule} from "@angular/forms";

@NgModule({
  imports: [
    CommonModule,
    IntFieldBoxModule,
    FormsModule,
    ReactiveFormsModule,
    IntLabeledFieldBoxModule
  ],
  declarations: [
    IntDefaultInputComponent,
    IntDefaultInputField
  ],
  exports: [
    IntDefaultInputComponent,
    IntDefaultInputField
  ]
})
export class IntDefaultInputModule {}
